import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  input {
    width: 40vw;
    max-width: 513px;
  }
`
export const StyledError = styled.p`
  width: 100%;
  color: red;
  padding-top: 10px;
  font-weight: 400;
  font-size: 12px;
`
